import styled from "styled-components";
import { brand_success, dark } from "../constants/styles";

// Live checklist — matches the User model's PASSWORD_FORMAT (see
// app/models/user.rb): min 6 chars, at least one digit, at least one upper
// case letter, at least one symbol. The checklist fades in once the user
// starts typing and is always visible to keep expectations clear.
//
// Labels only. The predicates live in `validatePassword` below, which is the
// single source of truth and is also what callers import to gate submission --
// this array previously carried its own duplicate `test` functions, including a
// tangled symbol check that disagreed with SYMBOL_RE, while the render ignored
// the array entirely and hardcoded all four rows. Keys match validatePassword's.
const RULES = [
  { id: "length", label: "Minimal 6 karakter" },
  { id: "digit", label: "Memuat angka" },
  { id: "upper", label: "Memuat huruf kapital" },
  { id: "symbol", label: "Memuat simbol" },
];

// Lightweight symbol check — the backend regex `(?=.*[[:^alnum:]])` matches
// any non-alphanumeric character. Mirror that with a simple JS regex.
const SYMBOL_RE = /[^a-zA-Z0-9]/;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px 16px;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${({ $ok }) => ($ok ? brand_success : "#6b7280")};
  transition: color 150ms ease;

  [data-theme="dark"] & {
    color: ${({ $ok }) => ($ok ? "#4ade80" : dark.text_secondary)};
  }
`;

const Dot = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background: ${({ $ok }) => ($ok ? brand_success : "#d1d5db")};

  [data-theme="dark"] & {
    background: ${({ $ok }) => ($ok ? "#16a34a" : "rgba(255,255,255,0.15)")};
  }
`;

export function validatePassword(pw) {
  const s = pw ?? "";
  return {
    length: s.length >= 6,
    digit: /\d/.test(s),
    upper: /[A-Z]/.test(s),
    symbol: SYMBOL_RE.test(s),
  };
}

export default function PasswordStrengthHint({ value }) {
  const checks = validatePassword(value);
  return (
    <List aria-live="polite">
      {RULES.map((rule) => (
        <Item key={rule.id} $ok={checks[rule.id]}>
          <Dot $ok={checks[rule.id]} aria-hidden="true">
            {checks[rule.id] ? "✓" : ""}
          </Dot>
          {rule.label}
        </Item>
      ))}
    </List>
  );
}
